import React from 'react';
import {
  Dialog, DialogActions, Typography, Button,
} from '@mui/material';

function WarnBeforeDeleting({
  onConfirm,
  onCancel,
  message,
  isOpen,
}) {
  return (
    <Dialog open={isOpen}>
      <DialogActions style={{ margin: '50px' }}>
        <div>
          <Typography variant="h6">{message}</Typography>
          <div style={{ float: 'right' }}>
            <Button onClick={onCancel} color="secondary">No</Button>
            <Button onClick={onConfirm} color="primary">Yes</Button>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}

export default WarnBeforeDeleting;
